import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-64e5ab2a")

_pushScopeId("data-v-64e5ab2a")
const _hoisted_1 = { class: "slide-style-panel" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "title" }, "背景填充", -1)
const _hoisted_3 = { class: "row" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("纯色填充")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("图片填充")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("渐变填充")
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { style: {"flex":"1"} }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode("原始大小")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("缩放")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("拼贴")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("缩放铺满")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("线性渐变")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("径向渐变")
const _hoisted_14 = {
  key: 0,
  class: "background-image-wrapper"
}
const _hoisted_15 = { class: "background-image" }
const _hoisted_16 = {
  key: 1,
  class: "background-gradient-wrapper"
}
const _hoisted_17 = { class: "row" }
const _hoisted_18 = /*#__PURE__*/_createVNode("div", { style: {"flex":"2"} }, "起点颜色：", -1)
const _hoisted_19 = { class: "row" }
const _hoisted_20 = /*#__PURE__*/_createVNode("div", { style: {"flex":"2"} }, "终点颜色：", -1)
const _hoisted_21 = {
  key: 0,
  class: "row"
}
const _hoisted_22 = /*#__PURE__*/_createVNode("div", { style: {"flex":"2"} }, "渐变角度：", -1)
const _hoisted_23 = { class: "row" }
const _hoisted_24 = /*#__PURE__*/_createTextVNode("应用背景到全部")
const _hoisted_25 = /*#__PURE__*/_createVNode("div", { class: "title" }, "全局主题", -1)
const _hoisted_26 = { class: "row" }
const _hoisted_27 = /*#__PURE__*/_createVNode("div", { style: {"flex":"2"} }, "字体：", -1)
const _hoisted_28 = { class: "row" }
const _hoisted_29 = /*#__PURE__*/_createVNode("div", { style: {"flex":"2"} }, "字体颜色：", -1)
const _hoisted_30 = { class: "row" }
const _hoisted_31 = /*#__PURE__*/_createVNode("div", { style: {"flex":"2"} }, "背景颜色：", -1)
const _hoisted_32 = { class: "row" }
const _hoisted_33 = /*#__PURE__*/_createVNode("div", { style: {"flex":"2"} }, "主题色：", -1)
const _hoisted_34 = /*#__PURE__*/_createVNode("div", {
  class: "title",
  style: {"margin-top":"20px"}
}, "预置主题：", -1)
const _hoisted_35 = { class: "theme-list" }
const _hoisted_36 = { class: "theme-item-content" }
const _hoisted_37 = { class: "row" }
const _hoisted_38 = /*#__PURE__*/_createTextVNode("应用主题到全部")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_SelectOption = _resolveComponent("SelectOption")
  const _component_Select = _resolveComponent("Select")
  const _component_ColorPicker = _resolveComponent("ColorPicker")
  const _component_ColorButton = _resolveComponent("ColorButton")
  const _component_Popover = _resolveComponent("Popover")
  const _component_IconPlus = _resolveComponent("IconPlus")
  const _component_FileInput = _resolveComponent("FileInput")
  const _component_Slider = _resolveComponent("Slider")
  const _component_Button = _resolveComponent("Button")
  const _component_Divider = _resolveComponent("Divider")
  const _component_SelectOptGroup = _resolveComponent("SelectOptGroup")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode(_component_Select, {
        style: {"flex":"10"},
        value: _ctx.background.type,
        onChange: _cache[1] || (_cache[1] = value => _ctx.updateBackgroundType(value))
      }, {
        default: _withId(() => [
          _createVNode(_component_SelectOption, { value: "solid" }, {
            default: _withId(() => [
              _hoisted_4
            ]),
            _: 1
          }),
          _createVNode(_component_SelectOption, { value: "image" }, {
            default: _withId(() => [
              _hoisted_5
            ]),
            _: 1
          }),
          _createVNode(_component_SelectOption, { value: "gradient" }, {
            default: _withId(() => [
              _hoisted_6
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["value"]),
      _hoisted_7,
      (_ctx.background.type === 'solid')
        ? (_openBlock(), _createBlock(_component_Popover, {
            key: 0,
            trigger: "click"
          }, {
            content: _withId(() => [
              _createVNode(_component_ColorPicker, {
                modelValue: _ctx.background.color,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = color => _ctx.updateBackground({ color }))
              }, null, 8, ["modelValue"])
            ]),
            default: _withId(() => [
              _createVNode(_component_ColorButton, {
                color: _ctx.background.color || '#fff',
                style: {"flex":"10"}
              }, null, 8, ["color"])
            ]),
            _: 1
          }))
        : (_ctx.background.type === 'image')
          ? (_openBlock(), _createBlock(_component_Select, {
              key: 1,
              style: {"flex":"10"},
              value: _ctx.background.size || 'cover',
              onChange: _cache[3] || (_cache[3] = value => _ctx.updateBackground({ imageSize: value }))
            }, {
              default: _withId(() => [
                _createVNode(_component_SelectOption, { value: "initial" }, {
                  default: _withId(() => [
                    _hoisted_8
                  ]),
                  _: 1
                }),
                _createVNode(_component_SelectOption, { value: "contain" }, {
                  default: _withId(() => [
                    _hoisted_9
                  ]),
                  _: 1
                }),
                _createVNode(_component_SelectOption, { value: "repeat" }, {
                  default: _withId(() => [
                    _hoisted_10
                  ]),
                  _: 1
                }),
                _createVNode(_component_SelectOption, { value: "cover" }, {
                  default: _withId(() => [
                    _hoisted_11
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value"]))
          : (_openBlock(), _createBlock(_component_Select, {
              key: 2,
              style: {"flex":"10"},
              value: _ctx.background.gradientType,
              onChange: _cache[4] || (_cache[4] = value => _ctx.updateBackground({ gradientType: value }))
            }, {
              default: _withId(() => [
                _createVNode(_component_SelectOption, { value: "linear" }, {
                  default: _withId(() => [
                    _hoisted_12
                  ]),
                  _: 1
                }),
                _createVNode(_component_SelectOption, { value: "radial" }, {
                  default: _withId(() => [
                    _hoisted_13
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value"]))
    ]),
    (_ctx.background.type === 'image')
      ? (_openBlock(), _createBlock("div", _hoisted_14, [
          _createVNode(_component_FileInput, {
            onChange: _cache[5] || (_cache[5] = files => _ctx.uploadBackgroundImage(files))
          }, {
            default: _withId(() => [
              _createVNode("div", _hoisted_15, [
                _createVNode("div", {
                  class: "content",
                  style: { backgroundImage: `url(${_ctx.background.image})` }
                }, [
                  _createVNode(_component_IconPlus)
                ], 4)
              ])
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (_ctx.background.type === 'gradient')
      ? (_openBlock(), _createBlock("div", _hoisted_16, [
          _createVNode("div", _hoisted_17, [
            _hoisted_18,
            _createVNode(_component_Popover, { trigger: "click" }, {
              content: _withId(() => [
                _createVNode(_component_ColorPicker, {
                  modelValue: _ctx.background.gradientColor[0],
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = value => _ctx.updateBackground({ gradientColor: [value, _ctx.background.gradientColor[1]] }))
                }, null, 8, ["modelValue"])
              ]),
              default: _withId(() => [
                _createVNode(_component_ColorButton, {
                  color: _ctx.background.gradientColor[0],
                  style: {"flex":"3"}
                }, null, 8, ["color"])
              ]),
              _: 1
            })
          ]),
          _createVNode("div", _hoisted_19, [
            _hoisted_20,
            _createVNode(_component_Popover, { trigger: "click" }, {
              content: _withId(() => [
                _createVNode(_component_ColorPicker, {
                  modelValue: _ctx.background.gradientColor[1],
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = value => _ctx.updateBackground({ gradientColor: [_ctx.background.gradientColor[0], value] }))
                }, null, 8, ["modelValue"])
              ]),
              default: _withId(() => [
                _createVNode(_component_ColorButton, {
                  color: _ctx.background.gradientColor[1],
                  style: {"flex":"3"}
                }, null, 8, ["color"])
              ]),
              _: 1
            })
          ]),
          (_ctx.background.gradientType === 'linear')
            ? (_openBlock(), _createBlock("div", _hoisted_21, [
                _hoisted_22,
                _createVNode(_component_Slider, {
                  min: 0,
                  max: 360,
                  step: 15,
                  value: _ctx.background.gradientRotate,
                  style: {"flex":"3"},
                  onChange: _cache[8] || (_cache[8] = value => _ctx.updateBackground({ gradientRotate: value }))
                }, null, 8, ["value"])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_23, [
      _createVNode(_component_Button, {
        style: {"flex":"1"},
        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.applyBackgroundAllSlide()))
      }, {
        default: _withId(() => [
          _hoisted_24
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_Divider),
    _createVNode(_component_Divider),
    _hoisted_25,
    _createVNode("div", _hoisted_26, [
      _hoisted_27,
      _createVNode(_component_Select, {
        style: {"flex":"3"},
        value: _ctx.theme.fontName,
        onChange: _cache[10] || (_cache[10] = value => _ctx.updateTheme({ fontName: value }))
      }, {
        default: _withId(() => [
          _createVNode(_component_SelectOptGroup, { label: "系统字体" }, {
            default: _withId(() => [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.availableFonts, (font) => {
                return (_openBlock(), _createBlock(_component_SelectOption, {
                  key: font.value,
                  value: font.value
                }, {
                  default: _withId(() => [
                    _createVNode("span", {
                      style: { fontFamily: font.value }
                    }, _toDisplayString(font.label), 5)
                  ]),
                  _: 2
                }, 1032, ["value"]))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(_component_SelectOptGroup, { label: "在线字体" }, {
            default: _withId(() => [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.webFonts, (font) => {
                return (_openBlock(), _createBlock(_component_SelectOption, {
                  key: font.value,
                  value: font.value
                }, {
                  default: _withId(() => [
                    _createVNode("span", null, _toDisplayString(font.label), 1)
                  ]),
                  _: 2
                }, 1032, ["value"]))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["value"])
    ]),
    _createVNode("div", _hoisted_28, [
      _hoisted_29,
      _createVNode(_component_Popover, { trigger: "click" }, {
        content: _withId(() => [
          _createVNode(_component_ColorPicker, {
            modelValue: _ctx.theme.fontColor,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = value => _ctx.updateTheme({ fontColor: value }))
          }, null, 8, ["modelValue"])
        ]),
        default: _withId(() => [
          _createVNode(_component_ColorButton, {
            color: _ctx.theme.fontColor,
            style: {"flex":"3"}
          }, null, 8, ["color"])
        ]),
        _: 1
      })
    ]),
    _createVNode("div", _hoisted_30, [
      _hoisted_31,
      _createVNode(_component_Popover, { trigger: "click" }, {
        content: _withId(() => [
          _createVNode(_component_ColorPicker, {
            modelValue: _ctx.theme.backgroundColor,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = value => _ctx.updateTheme({ backgroundColor: value }))
          }, null, 8, ["modelValue"])
        ]),
        default: _withId(() => [
          _createVNode(_component_ColorButton, {
            color: _ctx.theme.backgroundColor,
            style: {"flex":"3"}
          }, null, 8, ["color"])
        ]),
        _: 1
      })
    ]),
    _createVNode("div", _hoisted_32, [
      _hoisted_33,
      _createVNode(_component_Popover, { trigger: "click" }, {
        content: _withId(() => [
          _createVNode(_component_ColorPicker, {
            modelValue: _ctx.theme.themeColor,
            "onUpdate:modelValue": _cache[13] || (_cache[13] = value => _ctx.updateTheme({ themeColor: value }))
          }, null, 8, ["modelValue"])
        ]),
        default: _withId(() => [
          _createVNode(_component_ColorButton, {
            color: _ctx.theme.themeColor,
            style: {"flex":"3"}
          }, null, 8, ["color"])
        ]),
        _: 1
      })
    ]),
    _hoisted_34,
    _createVNode("div", _hoisted_35, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.themes, (item, index) => {
        return (_openBlock(), _createBlock("div", {
          class: "theme-item",
          key: index,
          style: { backgroundColor: item.background },
          onClick: ($event: any) => (_ctx.updateTheme({
          fontColor: item.text,
          backgroundColor: item.background,
          themeColor: item.color,
        }))
        }, [
          _createVNode("div", _hoisted_36, [
            _createVNode("div", {
              class: "text",
              style: { color: item.text }
            }, "Aa", 4),
            _createVNode("div", {
              class: "color-block",
              style: { backgroundColor: item.color }
            }, null, 4)
          ])
        ], 12, ["onClick"]))
      }), 128))
    ]),
    _createVNode("div", _hoisted_37, [
      _createVNode(_component_Button, {
        style: {"flex":"1"},
        onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.applyThemeAllSlide()))
      }, {
        default: _withId(() => [
          _hoisted_38
        ]),
        _: 1
      })
    ])
  ]))
})